import React from 'react';
import { Button, Tooltip } from 'antd';
import { CalendarOutlined, DollarOutlined, LinkOutlined } from '@ant-design/icons';
import { capability, actionReason } from '../../utilities/paymentPresentation';
const ACTIONS = [['link', 'Send payment link', 'can_create_link', LinkOutlined], ['record', 'Record payment', 'can_record_cash', DollarOutlined], ['settlement', 'Pay later / COD', 'can_manage_remainder', CalendarOutlined]];
// One primary button (the first available action); the others stay default.
export default function PrimaryActions({ projection, onAction }) {
  const rows = ACTIONS.map(([key, name, cap, Icon]) => {
    let value = capability(projection, cap);
    if (key === 'record') {
      const choices = ['can_record_cash', 'can_record_pos', 'can_report_bank_transfer'].map(name => capability(projection, name));
      value = choices.find(item => item.allowed) || choices.find(item => item.reason_code !== 'PERMISSION_REQUIRED') || value;
    }
    if (value.reason_code === 'PERMISSION_REQUIRED') return null;
    const revision = key === 'link' && (projection.summary?.revision_pending || projection.invoice_revisions?.some(row => ['pending_customer', 'pending_approval'].includes(row.status)));
    return { key, name, Icon, value, revision, enabled: value.allowed && !revision };
  }).filter(Boolean);
  const primaryKey = rows.find(row => row.enabled)?.key;
  return <div className="pv2-toolbar-actions">{rows.map(({ key, name, Icon, value, revision, enabled }) =>
    <Tooltip key={key} title={revision ? 'Finish the price revision first' : value.allowed ? null : actionReason(value)}>
      <Button type={key === primaryKey ? 'primary' : 'default'} icon={<Icon aria-hidden />} disabled={!enabled} onClick={() => onAction(key)}>{name}</Button>
    </Tooltip>)}</div>;
}
